import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { DynamicFormProps } from '@ui/interfaces'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

export default function NewRelicOtel(props: DynamicFormProps) {
  const schema = Yup.object({
    'api-key': Yup.string().required('API Key is required'),
  }).required()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div className="sm:col-span-4">
          {props.additionalInputs}
          <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
            API Key*
          </label>
          <div className="mt-2">
            <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600 sm:max-w-md">
              <input
                {...register('api-key')}
                type="text"
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                data-testid="new-relic-otel-api-key"
                placeholder="abc123"
                disabled={props.disableInputs}
              />
            </div>
            {errors['api-key'] && <p className="mt-2 text-xs italic text-red-500">{errors['api-key'].message}</p>}
          </div>
        </div>
      </div>
      {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
    </form>
  )
}
